export default {
  shipping: {
    officeName: '所属机构',
    officeAlias: '地址别名',
    contacts: '联系人',
    telphone: '电话',
    mobile: '手机',
    completeAddress: '地址',
    officeId: '所属机构',
    searchPlaceholder: '地址别名/机构名/联系人信息',
    addressTitle: '地址信息',
    loadadrType: '收发货类型',
    startTimeStr: '允收时间段-起',
    dueTimeStr: '允收时间段-止',
    warehouseName: '仓库名称',
    platformNo: '月台号',
    loadadrTypeOptions: ['收货', '发货'],
    placeholder: '多个用逗号隔开',
    areaId: '地址',
    zipCode: '邮政编码',
    detailAddress: '详细地址',
    longitude: '经度',
    latitude: '纬度',
    defaultAddressSign: '默认常用地址标志',
    setDefault: '设为默认地址'
  }
}
